module.exports = __webpack_public_path__ + "img/screenshotD.5b98d614.png";